export const KEYBOARD_NAVIGATION_TOOLTIP = 'keyboard-navigation-tooltip';
